<div class="panel mt-7 lg:col-span-2 xl:col-span-3">
    <div class="mb-5">
      <h5 class="text-2xl font-semibold text-center text-primary animate__animated animate__jackInTheBox animate__delay-1s">Ordenes de Servicio</h5>

    </div>
    <div class="mb-5">
      <div class="table-responsive font-semibold text-[#655151] dark:text-white-light">
        <table class="whitespace-nowrap">
          <thead>
            <tr class="animate__animated animate__zoomIn animate__delay-1s">
              <th>Factura</th>
              <th>Fecha</th>
              <th># ODS</th>
              <th>Taller</th>
              <th>Vehiculo</th>
              <th>Tipo de venta</th>
              <th>Medio</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody class="dark:text-white-dark text-center">
            <tr *ngFor="let ods of odsHistory" class="animate__animated animate__zoomInLeft animate__delay-1s">
              <td>{{ ods._id }}</td>
              <td class="">{{ ods.date }}</td>
              <td><a class="cursor-pointer hover:text-primary" (click)="openExternalLink(ods._id)"> {{ ods.consecutive }}</a></td>
              <td>{{ ods.service_center_name }}</td>
              <!-- <td>Ducati</td>
              <td>Contado</td> -->
              <td>{{ ods.sale_type }}</td>
              <td>{{ ods.payment_method }}</td>
              <td>{{ ods.total }}</td>
            </tr>
            <!-- <tr class="animate__animated animate__zoomInRight animate__delay-1s">
              <td>#00048</td>
              <td>2025-01-05</td>
              <td><a target="_blank" href="https://tuulapp.com/3/?i=65cd427fea4fa55251cd141a">#202402140002</a></td>
              <td>ZONA MOTORS SAS</td>
              <td>BMW</td>
              <td>Contado</td>
              <td>Efectivo</td>
              <td>$ 1.500.182,81</td>
            </tr>
            <tr class="animate__animated animate__zoomInLeft animate__delay-1s">
              <td>#00049</td>
              <td>2025-01-06</td>
              <td><a target="_blank" href="https://tuulapp.com/3/?i=65cd427fea4fa55251cd141a">#202402140002</a></td>
              <td>AUTOTECH SAS</td>
              <td>Roll Royce</td>
              <td>Contado</td>
              <td>Efectivo</td>
              <td>$ 3.500.182,81</td>
            </tr>
            <tr class="animate__animated animate__zoomInRight animate__delay-1s">
              <td>#00048</td>
              <td>2025-01-07</td>
              <td><a target="_blank" href="https://tuulapp.com/3/?i=65cd427fea4fa55251cd141a">#202402140002</a></td>
              <td>AUTOTECH SAS</td>
              <td>Chevrolet Spark</td>
              <td>Contado</td>
              <td>Efectivo</td>
              <td>$ 500.182,81</td>
            </tr>
            <tr class="animate__animated animate__zoomInLeft animate__delay-1s">
              <td>#00050</td>
              <td>2025-01-08</td>
              <td><a target="_blank" href="https://tuulapp.com/3/?i=65cd427fea4fa55251cd141a">#202402140002</a></td>
              <td>Silver Cars SAS</td>
              <td>Hyundai</td>
              <td>Contado</td>
              <td>Efectivo</td>
              <td>$ 700.182,81</td>
            </tr>
            <tr class="animate__animated animate__zoomInRight animate__delay-1s">
              <td>#00051</td>
              <td>2025-01-09</td>
              <td><a target="_blank" href="https://tuulapp.com/3/?i=65cd427fea4fa55251cd141a">#202402140002</a></td>
              <td>AUTOTECH SAS</td>
              <td>Toyota</td>
              <td>Contado</td>
              <td>Efectivo</td>
              <td>$ 100.182,81</td>
            </tr>
            <tr class="animate__animated animate__zoomInLeft animate__delay-1s">
              <td>#00052</td>
              <td>2025-01-10</td>
              <td><a target="_blank" href="https://tuulapp.com/3/?i=65cd427fea4fa55251cd141a">#202402140002</a></td>
              <td>Silver Cars SAS</td>
              <td>Toyota</td>
              <td>Contado</td>
              <td>Efectivo</td>
              <td>$ 300.182,81</td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
